import { createQueryKeys } from '@lukemorales/query-key-factory';

export const uae = createQueryKeys('uae', {
  model: null,
  adminModel: null,
});
